import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["associationDefinition", "cachedAssociationValuesForField", "value", "onChange", "error", "validationMessage", "required", "disabled", "isMulti", "placeholder", "clearable", "id"];
import { useMemo } from 'react';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { referenceToOption as defaultReferenceToOption } from 'reference-resolvers-lite/utils/referenceToOption';
import { CRM_OBJECT } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { normalizeAssociationValueAsString } from '../../utils/normalizeValue';
import { jsx as _jsx } from "react/jsx-runtime";
const contactFormatter = (reference, cachedAssociationValuesForField, disabled) => {
  var _reference$additional, _cachedAssociationVal;
  const option = defaultReferenceToOption(reference);
  // @ts-expect-error contents of `additionalProperties` are not typed but are guaranteed by the BE to be present
  const email = (_reference$additional = reference.additionalProperties) === null || _reference$additional === void 0 || (_reference$additional = _reference$additional.properties) === null || _reference$additional === void 0 ? void 0 : _reference$additional.email;
  if (reference.label !== '' && email) {
    option.text = `${reference.label} (${email})`;
  }
  if (reference.label === '' && !email) {
    option.text = '--';
  }
  const normalizedValue = option.value ? +option.value : 0;
  const valueIsExistingAssociation = (_cachedAssociationVal = cachedAssociationValuesForField.value) === null || _cachedAssociationVal === void 0 || (_cachedAssociationVal = _cachedAssociationVal.objectIds) === null || _cachedAssociationVal === void 0 ? void 0 : _cachedAssociationVal.includes(normalizedValue);
  if (disabled || valueIsExistingAssociation) {
    option.disabled = true;
  }
  if (valueIsExistingAssociation) {
    option.clearableValue = false;
  }
  return option;
};
const defaultFormatter = (reference, cachedAssociationValuesForField, disabled) => {
  var _cachedAssociationVal2;
  const option = defaultReferenceToOption(reference);
  const normalizedValue = option.value ? +option.value : 0;
  const valueIsExistingAssociation = (_cachedAssociationVal2 = cachedAssociationValuesForField.value) === null || _cachedAssociationVal2 === void 0 || (_cachedAssociationVal2 = _cachedAssociationVal2.objectIds) === null || _cachedAssociationVal2 === void 0 ? void 0 : _cachedAssociationVal2.includes(normalizedValue);
  if (disabled || valueIsExistingAssociation) {
    option.disabled = true;
  }
  if (valueIsExistingAssociation) {
    option.clearableValue = false;
  }
  return option;
};
export const AssociationInput = _ref => {
  var _value$length;
  let {
      associationDefinition,
      cachedAssociationValuesForField,
      value,
      onChange,
      error: __error = false,
      required: __required = false,
      disabled = false,
      isMulti = false,
      placeholder,
      clearable = true,
      id
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const toObjectTypeId = associationDefinition.toObjectTypeDefinition.objectTypeId;
  const resolver = createStandardCachedResolver(CRM_OBJECT, toObjectTypeId);
  const referenceToOption = useMemo(() => {
    return toObjectTypeId === CONTACT_TYPE_ID ? contactFormatter : defaultFormatter;
  }, [toObjectTypeId]);
  const normalizedValue = useMemo(() => {
    return normalizeAssociationValueAsString(value, isMulti);
  }, [value, isMulti]);
  const has50OrMoreCachedAssociationValues = cachedAssociationValuesForField.hasMore || isMulti && ((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0) === 50;
  const isDisabled = disabled || has50OrMoreCachedAssociationValues;
  return /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, Object.assign({}, props, {
    resolver: resolver,
    value: normalizedValue,
    onChange: onChange,
    multi: isMulti,
    multiCollapseLimit: 1,
    clearable: clearable,
    disabled: isDisabled,
    placeholder: placeholder,
    referenceToOption: reference => referenceToOption(reference, cachedAssociationValuesForField, isDisabled),
    "data-test-id": `association-input-${id}`
  }));
};
export default AssociationInput;